import './App.css';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {WindowParamContext, WindowParamContextProvider} from './library/context/WindowContext';
import {HomePage} from "./content/pages/HomePage";
import {MdPage} from "./content/pages/MdPage";
import {BusinessLicensePage} from "./content/pages/BusinessLicensePage";
import {LotTestPage} from "./content/pages/LotTestPage";
import { AdminPage } from './content/pages/AdminPage';


function App() {
    return (
        <WindowParamContextProvider>
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;
                    return (
                        <Router basename='/'>
                            <Routes key={window.location.pathname} location={window.location}>
                                <Route path="" element={<HomePage
                                    key={"HomePage" + wp.version}></HomePage>}></Route>
                                {/*<Route path="/lot" element={<LotTestPage*/}
                                {/*    key={"LotTestPage" + wp.version}></LotTestPage>}></Route>*/}
                                <Route path="/admin" element={<AdminPage
                                    key={"AdminPage" + wp.version}></AdminPage>}></Route>

                                {/*隐私协议、证照信息等页面*/}
                                <Route path="/membership"
                                       element={<MdPage key={"MdPage" + wp.version}></MdPage>}></Route>
                                <Route path="/privacypolicy"
                                       element={<MdPage key={"MdPage" + wp.version}></MdPage>}></Route>
                                <Route path="/useragreement"
                                       element={<MdPage key={"MdPage" + wp.version}></MdPage>}></Route>
                                <Route path="/license" element={<MdPage key={"MdPage" + wp.version}></MdPage>}></Route>
                                <Route path="/businesslicense"
                                       element={<BusinessLicensePage key={"BusinessLicensePage" + wp.version}></BusinessLicensePage>}></Route>
                                <Route path="/contact"
                                       element={<MdPage key={"MdPage" + wp.version}></MdPage>}></Route>
                                <Route path="/windflow" element={<HomePage
                                    key={"HomePage" + wp.version}></HomePage>}></Route>
                            </Routes>
                        </Router>
                    )
                }
                }
            </WindowParamContext.Consumer>
        </WindowParamContextProvider>
    );
}

export default App;
